export const SHIPMENT_LIST_TEST_ID = 'ShipmentList';
export const SHIPMENT_LIST_ITEM_TEST_ID = 'ShipmentListItem';
export const SHIPMENT_LIST_TRACK_IDENTIFIER_TEST_ID = 'ShipmentListTrackIdentifier';
export const SHIPMENT_LIST_MILESTONE_TEST_ID = 'ShipmentListMilestone';
export const SHIPMENT_LIST_EDD_TEST_ID = 'ShipmentListEdd';
export const SHIPMENT_LIST_FLIGHT_STATUS_TEST_ID = 'ShipmentListFlightStatus';
export const SHIPMENT_LIST_ENQUIRY_TEST_ID = 'ShipmentListEnquiry';
export const SHIPMENT_LIST_ENQUIRY_BLANK_TEST_ID = 'ShipmentListNoEnquiry';
export const SHIPMENT_LIST_ENQUIRY_LINK_TEST_ID = 'ShipmentListEnquiryLink';
